import Wrap from './styles';

/**
 * PropTypes é um mecanismo utilizado para garantir que os 
 * componentes usem o tipo de dados correto e passem os dados corretos
 */
import PropTypes from 'prop-types';

/**
 * Wrapper para conteúdos que deve ser ocultados no Mobile
 */
export const Desktop = ({ children }) => {
  return <Wrap>{children}</Wrap>;
};

Desktop.propTypes = {
  children: PropTypes.any,
};

Desktop.properties = {
  ignore: true,
};

export default Desktop;
